/** @format */

import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor() {}

  //완료 메세지
  successmsg(text: string, title = '') {
    return Swal.fire({
      title,
      text,
      icon: 'success',
      confirmButtonText: '확인',
      customClass: {
        confirmButton: 'btn btn-success swal-alert-btn',
      },
    });
  }
  //에러 메세지
  errormsg(text: string, title = '') {
    return Swal.fire({
      title,
      text,
      icon: 'error',
      confirmButtonText: `닫기`,
      customClass: {
        confirmButton: 'btn btn-success swal-alert-btn',
      },
    });
  }

  //긍정적 컴펌 메세지
  successConfirm(text, confirmButtonText = '확인', title = '') {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title,
        text,
        icon: 'success',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        customClass: {
          confirmButton: 'swal-alert-btn',
          cancelButton: 'swal-alert-btn',
        },
        confirmButtonText,
        cancelButtonText: '취소',
        reverseButtons: true,
      })
        .then((result) => {
          if (result.value) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // 부정적 컴펌 메세지
  warningConfirm(text, confirmButtonText = '확인', title = '') {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title,
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        customClass: {
          confirmButton: 'swal-alert-btn',
          cancelButton: 'swal-alert-btn',
        },
        confirmButtonText,
        cancelButtonText: '취소',
      })
        .then((result) => {
          if (result.value) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //토스트
  swalToast(title, icon?) {
    Swal.fire({
      toast: true,
      timerProgressBar: true,
      position: 'bottom',
      icon: icon ? icon : 'success',
      title,
      showConfirmButton: false,
      timer: 2000,
    });
  }

  //이미지 얼럿
  imageHeader(title, text, imageUrl, imageHeight) {
    Swal.fire({
      title,
      text,
      imageUrl,
      imageHeight,
      confirmButtonColor: '#556ee6',
    });
  }

  //타이머 strong 태그안에 시간이 들어가도록 세팅해주세요.
  timer(title, html) {
    let timerInterval;

    Swal.fire({
      title,
      html,
      timer: 2000,
      didOpen: () => {
        Swal.showLoading();
        timerInterval = setInterval(() => {
          Swal.getContainer().querySelector('strong').textContent =
            Swal.getTimerLeft() + '';
        }, 100);
      },
      willClose: () => {
        clearInterval(timerInterval);
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
      }
    });
  }
}
